/** 同时支持 EVM 扩展 + Tron 注入的双轨钱包 */
import { isInjectWalletAvailable } from './dapp/inject.mjs'
import { isTronInjectWalletAvailable, TRON_INJECT_KEYS } from './dapp/tronInject.mjs'
import { isMetaMaskTronAvailable } from './dapp/metamaskTron.mjs'
import { waitForInjectProbe } from './dapp/injectProbe.mjs'

export const DUAL_RAIL_WALLET_KEYS = new Set([
  'tokenPocket',
  'bitget',
  'ave',
  'binance',
  'okx',
  'metamask',
])

export function isDualRailInjectWallet(wallet) {
  return wallet?.type === 'inject' && DUAL_RAIL_WALLET_KEYS.has(String(wallet?.key || ''))
}

export function shouldShowEcosystemPicker(_wallet, { isMobile = false } = {}) {
  // Bridge 按发起链分流：EVM 页只连 EVM、TRON 页只连 TRON，不在连接弹窗内二次选链。
  // 用户切换网络应回到页面「从」链选择，与原先业务一致。
  return false
}

/** @deprecated 保留探测供安装引导 / 测试；UI 不再展示双轨选链面板 */
export function isEcosystemPickerEnabled() {
  return false
}

/** 探测双轨钱包在当前浏览器是否已注入 EVM / TRON */
export async function probeDualRailInject(wallet) {
  await waitForInjectProbe({ timeoutMs: 900 })
  const key = String(wallet?.key || '')
  const evm = isInjectWalletAvailable(wallet)
  let tron = false
  if (key === 'metamask') {
    tron = evm ? await isMetaMaskTronAvailable() : false
  } else if (TRON_INJECT_KEYS.has(key)) {
    tron = isTronInjectWalletAvailable(wallet)
  }
  return { evm, tron, anyInject: evm || tron }
}
